import link from "@/scripts/host.js";
import loggedIn from '@/scripts/logged.js';
import handleError from '@/scripts/handleError.js'



export default {
  name: "DeleteAccount",
  props: ["close"],
  data() {
    return {
      newEmail: "",
      repeatEmail: "",
      invalid: false
    };
  },
  methods: {
    closeModal() {
      this.$store.dispatch("toggleLoginModal");
    },


    async deleteAcc() {
      let token = await loggedIn();

      this.axios({
        method: "post",
        url: `${link.hostLink}Account/DeleteAccount`,
        headers: {authorization: `bearer ${token}`}

      })
        .then(() => {
          this.$store.dispatch('setGenericModalText', 'Konto został pomyślnie usunięte.');

          this.$store.dispatch('setModalType', 'genericModal');
          localStorage.removeItem('user');
          sessionStorage.removeItem('user');

        })
        .catch(function(error) {
          handleError(error.response)
        });

    }
  },

  mounted() {}
}
